import { useEffect, useState } from 'react';
import { StatusDropdownOption } from './StatusDropdown';
import { DealStatus } from '../../../store/investor/reducer';

export const useCustomFilteringLogic = (searchTerm, field, dropdownOptions, restrictBackwardMovement, selectedOptionIndex) => {
    const [filteredOptions, setFilteredOptions] = useState<StatusDropdownOption[]>([]);

    useEffect(() => {
        updateFilterActionsBackwardMovement();
    }, [dropdownOptions, restrictBackwardMovement, selectedOptionIndex, searchTerm]);

    const isDealInLastStage = () => {
        return (
            field === 'dealStatus' &&
            [
                DealStatus.FIRST_DEAL_DISBURSED,
                DealStatus.ALL_UNRESPONSIVE,
                DealStatus.ALL_PASSED,
                DealStatus.DISBURSED,
                DealStatus.UNRESPONSIVE,
                DealStatus.PASSED,
            ].includes(dropdownOptions?.[selectedOptionIndex]?.value)
        );
    };

    const updateFilterActionsBackwardMovement = () => {
        if (isDealInLastStage()) {
            setFilteredOptions([]);
            return;
        }
        setFilteredOptions(
            dropdownOptions.filter((option, index) => {
                if (restrictBackwardMovement && index <= selectedOptionIndex) {
                    return false;
                }
                return option?.label?.toLowerCase().includes(searchTerm.toLowerCase()) || false;
            }),
        );
    };

    return { filteredOptions };
};
